import React, { useEffect, useState } from "react";import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import styled from "styled-components";
import colors from "../../constants/colors";

const Button = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;

  width: 48px;
  height: 48px;
  border: none;
  border-radius: 50%;

  background: ${colors.PRIMARY};
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 9999;

  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
  }
`;
const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!visible) return null;

  return (
    <Button onClick={scrollToTop}>
      <KeyboardArrowUpIcon />
    </Button>
  );
};

export default ScrollToTopButton;